import {FETCH_NUMBER_FILTER, LIST_NUMBER_FILTER} from "./types";


const init = {
    filter: {},
    data: {}

};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_NUMBER_FILTER:
            return {
                ...state,
                filter: payload,
            };
        case LIST_NUMBER_FILTER:
            return {
                ...state,
                data: payload.data?.filter
            };
        default:
            return state

    }
}
